import type { UseQueryOptions } from 'react-query';
import { useQuery } from 'react-query';

import type { Account } from '@evenfinancial/finance-client';

import type { IAccountsQuery } from '@portal/api-models';

import { client } from '../client';
import { QueryKey } from '../types';

export const getFinanceAccounts = async (params?: IAccountsQuery) =>
  client
    .get<Account[]>('/finance/accounts', { params })
    .then(({ data }) => data);

export const useGetFinanceAccountsQuery = (
  params?: IAccountsQuery,
  options?: Omit<UseQueryOptions<Account[]>, 'queryKey' | 'queryFn'>
) =>
  useQuery(
    [QueryKey.Accounts, params],
    async () => getFinanceAccounts(params),
    options
  );
